<div *ngIf="form$ | async; let mxForm; ">
  <div *ngIf="formMode === 'readonly'; else editableForm"
       class="mx-list-wrapper"
       [ngClass]="{'full-mode': !showOnlyCompactModeFields}">
    <mat-list>
      <mx-dynamic-fields [form]= "mxForm"
                         [fields]="(fields$ | async) | filterByProp:'showInCompactMode':showOnlyCompactModeFields"
                         [readonlyMode]="true"
                         [fieldConfigs]="fieldConfigs"
                         [layoutClass]="layoutClass"
                         [ngClass]="{'with-width30': layoutClass}"
                         [errorMessage]="showErrorMessage"
                         class="mx-form-fields">
      </mx-dynamic-fields>
    </mat-list>

    <div class="divider-wrapper" *ngIf="showDivider">
      <mat-divider></mat-divider>
      <button mat-icon-button
              class="divider-button"
              type="button"
              (click)="toggleFullMode()">
        <i class="material-icons">
          keyboard_arrow_down
        </i>
      </button>
    </div>
  </div>

  <ng-template #editableForm>
    <form class="mxs-form" #form
          [formGroup]="mxForm">
      <mx-dynamic-fields [form]= "mxForm"
                         [fields]="fields$ | async"
                         [readonlyMode]="false"
                         [errorMessage]="showErrorMessage"
                         [fieldConfigs]="fieldConfigs"
                         [layoutClass]="layoutClass"
                         [ngClass]="{'with-width30': layoutClass}"
                         class="mx-form-fields">
          <ng-container ngProjectAs="mx-form-footer">
            <ng-content select="mx-form-footer"></ng-content>
          </ng-container>
      </mx-dynamic-fields>
    </form>
  </ng-template>

</div>
